import { InitiateConsentResponseType } from '../../Utils/types';
import {
  getAccessToken,
  getTemplateType,
  getUserId,
} from '../../Utils/storageUtils';
import pfmClientAxiosInstance, { pfmAxiosInstance } from './interceptor';

export const initiateConsent = async ({
  userId,
}: {
  userId: string | null;
}) => {
  try {
    const response = await pfmClientAxiosInstance.post(
      `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/consent/${userId}/initiate-consent`,
      {
        userId,
        fipIds: ['FIP-ID'],
        templateType: [getTemplateType() ? getTemplateType() : 'PFM_BANKS'],
      },
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response;
  } catch (e) {
    return { data: 'ERROR' };
  }
};

      const SECRET_KEY_HEX = '30928390820938290380283829038028';
      const KEY_VERSION = '1';

      function hexToBytes(hex: any) {
        const bytes = new Uint8Array(hex.length / 2);
        for (let i = 0; i < bytes.length; i++) {
          bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
        }
        return bytes;
      }

      function bytesToHex(bytes: any) {
        return Array.from(bytes)
          .map((b: any) => b.toString(16).padStart(2, '0'))
          .join('');
      }

      async function encryptAESGCM(plainText: any, hexKey: any) {
        const keyBytes = hexToBytes(hexKey);
        const iv = new Uint8Array(12); // ZERO IV

        const cryptoKey = await crypto.subtle.importKey(
          'raw',
          keyBytes,
          'AES-GCM',
          false,
          ['encrypt'],
        );

        const encoded = new TextEncoder().encode(plainText);

        const encryptedBuffer = await crypto.subtle.encrypt(
          {
            name: 'AES-GCM',
            iv: iv,
            tagLength: 128,
          },
          cryptoKey,
          encoded,
        );

        return bytesToHex(new Uint8Array(encryptedBuffer));
      }

      async function decryptAESGCM(encryptedHex: any, hexKey: any) {
        const keyBytes = hexToBytes(hexKey);
        const iv = new Uint8Array(12); // ZERO IV

        const cryptoKey = await crypto.subtle.importKey(
          'raw',
          keyBytes,
          'AES-GCM',
          false,
          ['decrypt'],
        );

        const encryptedBytes = hexToBytes(encryptedHex);

        const decryptedBuffer = await crypto.subtle.decrypt(
          {
            name: 'AES-GCM',
            iv: iv,
            tagLength: 128,
          },
          cryptoKey,
          encryptedBytes,
        );

        return new TextDecoder().decode(decryptedBuffer);
      }




export const initiateJourney = async () => {
  try {
    const payload = {
        phoneNumber: getUserId(),
        trackingId: crypto.randomUUID(),
        templateTypes: ['PFM'],
      };

      console.log(JSON.stringify(payload))

      const encryptedPayload = await encryptAESGCM(
        JSON.stringify(payload),
        SECRET_KEY_HEX,
      );

      console.log("encyptedRequest " , encryptedPayload);

    const response = await pfmAxiosInstance.post(
      `${process.env.REACT_APP_PFM_BASEURL}/web/initiate`,
      {
        encryptedPayload,
        "keyVersion": "1"
      }      
    );

      const encryptedResponse: any = response;

      console.log( "encryptedResponse " , encryptedResponse )

      const decryptedResponseText = await decryptAESGCM(
        encryptedResponse.data.encryptedPayload,
        SECRET_KEY_HEX,
      );

      const responseBody = JSON.parse(decryptedResponseText);

      console.log( 'decryptedResponse' , responseBody);

    return responseBody;
  } catch (e) {
    return { data: 'ERROR' };
  }
};
